import { Sparkles, ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function PromoStrip() {
  return (
    <section data-testid="promo-strip" className="bg-midnight px-6 pb-28 text-linen md:pb-32 lg:px-10">
      <Reveal>
        <button
          data-testid="promo-strip-button"
          onClick={() => window.scrollToSection?.("#promo")}
          className="group mx-auto flex w-full max-w-7xl flex-col items-start justify-between gap-6 border border-white/15 bg-deepblue/60 px-8 py-8 text-left transition-colors duration-300 hover:border-dusty md:flex-row md:items-center md:px-12"
        >
          <div className="flex items-start gap-5">
            <Sparkles className="mt-1 h-5 w-5 shrink-0 text-dusty" />
            <div>
              <p className="text-xs font-medium uppercase tracking-[0.35em] text-dusty">Promozione infrasettimanale</p>
              <p className="mt-2 font-serif text-2xl leading-snug sm:text-3xl">
                Dal lunedì al giovedì, il tuo evento tutto incluso a <span className="italic text-dusty">1.750 €</span>
              </p>
              <p className="mt-2 text-sm font-light text-linen/60">per 40 persone · e tre sorprese da scoprire</p>
            </div>
          </div>
          <span className="inline-flex shrink-0 items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-dusty transition-transform duration-300 group-hover:translate-x-1">
            Scopri <ArrowUpRight className="h-4 w-4" />
          </span>
        </button>
      </Reveal>
    </section>
  );
}
